import React from 'react';
import { useQueryString } from 'helpers/effects';
import PaidAdReviewList from 'components/PaidAd/Review';

const ScreenPaidAdReviewList = () => {
  const initialFilters = useQueryString();
  return <PaidAdReviewList initialFilters={initialFilters} />;
};

export default ScreenPaidAdReviewList;
